import React from 'react';

const ContactUsContent = ({ submenuKey }) => {
  return (
    <div className="animate-fadein">
      {submenuKey === 'contact' && <h2>Contact Us Content</h2>}
    </div>
  );
};

export default ContactUsContent; 